import React from "react";
import { motion } from "framer-motion";
import {
  FiUser,
  FiFileText,
  FiLayers,
  FiActivity,
  FiAward,
  FiStar,
} from "react-icons/fi";
import "./TabNavigation.css";

const tabs = [
  { id: "overview", label: "Overview", icon: FiUser },
  { id: "posts", label: "Posts", icon: FiFileText, countKey: "posts" },
  { id: "research", label: "Research", icon: FiLayers, countKey: "research" },
  { id: "activity", label: "Activity", icon: FiActivity },
  { id: "endorsements", label: "Skills", icon: FiAward },
  { id: "reviews", label: "Reviews", icon: FiStar },
];

const TabNavigation = ({ activeTab, handleTabChange, stats }) => {
  // Calculate total research items
  const researchTotal =
    (stats?.communities || 0) + (stats?.rooms || 0) + (stats?.workshops || 0);

  const getCount = (countKey) => {
    if (countKey === "posts") return stats?.posts || 0;
    if (countKey === "research") return researchTotal;
    return 0;
  };

  return (
    <nav className="prf-tabs-nav" role="tablist" aria-label="Profile sections">
      <div className="prf-tabs-container">
        <div className="prf-tabs-list">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const count = tab.countKey ? getCount(tab.countKey) : null;
            const isActive = activeTab === tab.id;

            return (
              <motion.button
                key={tab.id}
                className={`prf-tab ${isActive ? "active" : ""}`}
                onClick={() => handleTabChange(tab.id)}
                role="tab"
                aria-selected={isActive}
                aria-controls={`${tab.id}-panel`}
                id={`${tab.id}-tab`}
                whileHover={{ y: -1 }}
                whileTap={{ scale: 0.98 }}
              >
                <Icon className="prf-tab-icon" />
                <span className="prf-tab-label">{tab.label}</span>
                {count > 0 && (
                  <motion.span
                    className="prf-tab-count"
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ type: "spring", stiffness: 500, damping: 25 }}
                  >
                    {count}
                  </motion.span>
                )}
                {isActive && (
                  <motion.div
                    className="prf-tab-indicator"
                    layoutId="activeTab"
                    transition={{ type: "spring", stiffness: 380, damping: 30 }}
                  />
                )}
              </motion.button>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default TabNavigation;
